function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.333 6.83a.703.703 0 010 .994L3.05 9.109h6.762a.703.703 0 110 1.406H3.05L4.334 11.8a.704.704 0 01-.994.994L.855 10.31a.703.703 0 010-.994L3.34 6.829a.703.703 0 01.994 0zm5.333-5.624a.703.703 0 01.928-.058l.066.058 2.485 2.485a.702.702 0 01.059.928l-.059.066L10.66 7.17a.703.703 0 01-1.053-.928l.059-.066 1.284-1.285H4.188a.703.703 0 01-.082-1.4l.082-.006h6.763L9.666 2.2a.703.703 0 010-.993z",
  fill: "currentColor"
});

var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgTransfer;